import { createFileRoute } from "@tanstack/react-router";
import AdminInventoryCleanSync from "@/pages/admin/AdminInventoryCleanSync";

export const Route = createFileRoute("/_adminLayout/admin/inventory-clean-sync")({
  component: AdminInventoryCleanSync,
});
